// @ts-nocheck
"use client"

import { useMemo } from "react"
import { ScrollArea } from "@/components/ui/scroll-area"
import type { GetContractResponseContent } from "src/types/contract.types"
import IqModeAnalysis from "../IqModeAnalysis"

interface IqQuestionsPanelProps {
  contract?: GetContractResponseContent
  onTermSelect?: (termWithInstance: string) => void
}

export function getIqQuestionCount(contract?: GetContractResponseContent): number {
  if (!contract?.iqData?.iqModeData) return 0
  return Object.values(contract.iqData.iqModeData).reduce((sum, perspective) => {
    const sections = perspective?.sections ? Object.values(perspective.sections) : []
    const perspectiveCount = sections.reduce((sectionSum, section) => {
      return sectionSum + (section?.questions?.length || 0)
    }, 0)
    return sum + perspectiveCount
  }, 0)
}

export function IqQuestionsPanel({ contract, onTermSelect }: IqQuestionsPanelProps) {
  const hasIqData = useMemo(() => {
    return Boolean(contract?.iqData?.iqModeData && Object.keys(contract.iqData.iqModeData).length > 0)
  }, [contract?.iqData?.iqModeData])

  if (!contract || !hasIqData) {
    return (
      <ScrollArea className="flex-1">
        <div className="px-4 py-4">
          <p className="text-sm text-muted-foreground">No IQ questions available for this contract.</p>
        </div>
      </ScrollArea>
    )
  }

  return (
    <ScrollArea className="flex-1">
      <div className="px-4 py-4">
        <IqModeAnalysis contract={contract} questionsOnly onTermSelect={onTermSelect} />
      </div>
    </ScrollArea>
  )
}
